import { Platform, View } from 'react-native';
import React, { useCallback } from 'react';
import {
  Banner,
  Footer,
  Input,
  KeyboardScreenContainer,
  Text,
} from '~/components';
import type { MarisaAutoStepsProps } from '../..';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { isValidExpiryDate } from '~/utils/yup';
import useMarisaAutoForm from '~/stores/marisaAutoForm';

const schema = yup
  .object()
  .shape({
    expiryDate: isValidExpiryDate(),
  })
  .required();

interface InsuranceExpiryForm {
  expiryDate: string;
}

const InsuranceExpiry = ({ onContinue }: MarisaAutoStepsProps) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<InsuranceExpiryForm>({
    resolver: yupResolver(schema),
  });

  const { setExpiryDate } = useMarisaAutoForm();

  const onSubmit = useCallback(
    (data: InsuranceExpiryForm) => {
      setExpiryDate(data.expiryDate);

      onContinue();
    },
    [onContinue, setExpiryDate]
  );

  return (
    <KeyboardScreenContainer
      footer={
        <View
          className={`flex xl:hidden ${
            Platform.OS === 'web' ? 'py-4 px-6' : ''
          }`}
        >
          <Footer onSubmit={handleSubmit(onSubmit)} />
        </View>
      }
    >
      <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
        <Banner type="marisa-auto" />

        <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
          <Text className="text-xl mb-4 text-gray-600">
            Qual a data de vencimento do seu seguro?
          </Text>

          <Text className="text-gray-400 text-sm mb-8">
            Verifique no documento da sua apólice o fim da vigência do seguro
          </Text>

          <Input
            name="expiryDate"
            label="Data de vencimento"
            placeholder="MM/AAAA"
            control={control}
            maskConfig={{
              type: 'custom',
              mask: '99/9999',
            }}
            maxLength={7}
            error={errors.expiryDate?.message}
            keyboardType="number-pad"
          />

          <Footer className="hidden" onSubmit={handleSubmit(onSubmit)} />
        </View>
      </View>
    </KeyboardScreenContainer>
  );
};

export default InsuranceExpiry;
